import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus",
  "use": "plus-usage",
  "viewBox": "0 0 640 640",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 640 640\" id=\"plus\">\n<title></title>\n<g id=\"plus_icomoon-ignore\"></g>\n<path d=\"M512 288h-160v-160h-64v160h-160v64h160v160h64v-160h160z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol